class InventoryDisplay extends HTMLElement {
  constructor() {
    super();
    this.variantChangeUnsubscriber = undefined;
  }

  connectedCallback() {
    this.variantChangeUnsubscriber = subscribe(
      PUB_SUB_EVENTS.optionValueSelectionChange,
      this.handleVariantChange.bind(this)
    );
  }

  disconnectedCallback() {
    if (this.variantChangeUnsubscriber) {
      this.variantChangeUnsubscriber();
    }
  }

  handleVariantChange(event) {
    const variant = event.data.variant;
    if (!variant) {
      this.style.display = 'none';
      return;
    }

    this.updateInventoryDisplay(variant);
  }

  updateInventoryDisplay(variant) {
    // Only show inventory if it's being tracked and enabled in settings
    if (!variant.inventory_management || !window.inventorySettings?.showIndicators) {
      this.style.display = 'none';
      return;
    }

    this.style.display = 'block';
    const inventoryQuantity = variant.inventory_quantity;
    const available = variant.available;
    
    // Get thresholds from settings or use defaults
    const criticalThreshold = window.inventorySettings?.criticalThreshold || 10;
    const lowThreshold = window.inventorySettings?.lowThreshold || 20;
    
    let displayClass = '';
    let indicatorHtml = '<span class="inventory-indicator"></span>';
    let textContent = '';

    if (!available) {
      displayClass = 'inventory-out';
      textContent = this.getTranslation('out_of_stock', 'Out of stock');
    } else if (inventoryQuantity > 0 && inventoryQuantity < criticalThreshold) {
      displayClass = 'inventory-critical';
      textContent = this.getTranslation('low_stock_with_quantity', `Only ${inventoryQuantity} left in stock!`, { quantity: inventoryQuantity });
    } else if (inventoryQuantity >= criticalThreshold && inventoryQuantity <= lowThreshold) {
      displayClass = 'inventory-low';
      textContent = this.getTranslation('limited_stock', `Limited stock - ${inventoryQuantity} remaining`, { quantity: inventoryQuantity });
    } else if (inventoryQuantity > lowThreshold || variant.inventory_policy === 'continue') {
      displayClass = 'inventory-good';
      textContent = this.getTranslation('in_stock', 'In stock');
    }

    if (displayClass) {
      let shippingInfo = '';
      if (displayClass === 'inventory-good') {
        const shippingText = this.getTranslation('ships_within_24h', 'Usually ships within 24 hours');
        shippingInfo = `
          <div class="inventory-shipping-info">
            <svg class="truck-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <rect x="1" y="3" width="15" height="13"></rect>
              <polygon points="16 8 20 8 23 11 23 16 16 16 16 8"></polygon>
              <circle cx="5.5" cy="18.5" r="2.5"></circle>
              <circle cx="18.5" cy="18.5" r="2.5"></circle>
            </svg>
            <span>${shippingText}</span>
          </div>
        `;
      }
      
      this.innerHTML = `
        <div class="inventory-display ${displayClass}">
          ${indicatorHtml}
          <span class="inventory-text">${textContent}</span>
        </div>
        ${shippingInfo}
      `;
    } else {
      this.style.display = 'none';
    }
  }

  getTranslation(key, fallback, replacements = {}) {
    // Try to get translation from window.theme if available
    if (window.theme && window.theme.strings && window.theme.strings.inventory && window.theme.strings.inventory[key]) {
      let translation = window.theme.strings.inventory[key];
      // Replace placeholders
      Object.keys(replacements).forEach(placeholder => {
        translation = translation.replace(`{{ ${placeholder} }}`, replacements[placeholder]);
      });
      return translation;
    }
    
    // Fallback with replacements
    let result = fallback;
    Object.keys(replacements).forEach(placeholder => {
      result = result.replace(`{{ ${placeholder} }}`, replacements[placeholder]);
    });
    return result;
  }
}

customElements.define('inventory-display', InventoryDisplay);